import { CartAddEvent } from '@theme/events';

class OfferQuickAdd extends HTMLElement {
  connectedCallback() {
    this.addEventListener('submit', this.submit);
  }

  disconnectedCallback() {
    this.removeEventListener('submit', this.submit);
  }

  submit = async (event) => {
    event.preventDefault();
    if (this.busy) return;
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.reportValidity()) return;
    const data = new FormData(form);
    if (!data.get('id')) return;
    const button = form.querySelector('button');
    const label = button.querySelector('[data-button-text]');
    const status = form.querySelector('[role="status"]');
    const select = form.querySelector('select');
    const originalText = label.textContent;
    this.busy = true;
    button.disabled = true;
    if (select) select.disabled = true;
    form.setAttribute('aria-busy', 'true');
    label.textContent = 'Adding...';
    status.textContent = '';

    const sections = [...new Set([...document.querySelectorAll('cart-items-component')]
      .map((item) => item.dataset.sectionId).filter(Boolean))].slice(0, 5);
    if (sections.length) data.set('sections', sections.join(','));
    data.set('sections_url', window.location.pathname);

    try {
      const response = await fetch(form.action, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: data,
      });
      const result = await response.json();
      if (!response.ok || result.status) {
        throw new Error(result.description || result.message || 'Unable to add this item. Please try again.');
      }
      status.textContent = 'Added to cart';
      this.dispatchEvent(new CartAddEvent({}, String(data.get('id')), {
        source: 'product-form-component',
        productId: this.dataset.productId,
        itemCount: 1,
        sections: result.sections,
      }));
    } catch (error) {
      status.textContent = error instanceof TypeError
        ? 'Connection interrupted. Check your cart before trying again.'
        : error.message;
    } finally {
      this.busy = false;
      button.disabled = false;
      if (select) select.disabled = false;
      label.textContent = originalText;
      form.removeAttribute('aria-busy');
    }
  };
}

if (!customElements.get('offer-quick-add')) {
  customElements.define('offer-quick-add', OfferQuickAdd);
}
